import { CommonModule } from '@angular/common';
import { Component, OnInit, effect, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Interval, PaymentService, PurchaseProduct } from '@app/services/payment.service';
import { ProductBoxComponent } from '../product-box/product-box.component';
import { TranslocoService } from '@jsverse/transloco';
import { SelectButton } from 'primeng/selectbutton';

export type SelectButtonOption = {
  label: string;
  value: string;
};

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  standalone: true,
  imports: [CommonModule, ProductBoxComponent, SelectButton, FormsModule],
})
export class ProductListComponent implements OnInit {
  paymentService = inject(PaymentService);
  translocoService = inject(TranslocoService);

  DEFAULT_INTERVAL: Interval = 'year';

  subscriptionProducts = signal<(PurchaseProduct | undefined)[]>([undefined, undefined]);
  loadingProducts = signal<boolean>(false);

  intervalOptions = signal<SelectButtonOption[]>([]);
  selectedInterval = signal<Interval>(this.DEFAULT_INTERVAL);

  ngOnInit() {
    this.loadingProducts.set(true);
    this.paymentService.requestPaymentProducts().then(({ data: products, error }) => {
      if (error) {
        console.error('[ProductListComponent] Error fetching payment products:', error);
        this.loadingProducts.set(false);
        return;
      }

      products = products || [];

      products.sort((a, b) => {
        return Number((a.metadata as any)['sort_order']) > Number((b.metadata as any)['sort_order']) ? 1 : -1;
      });
      this.subscriptionProducts.set(products);
      this.loadingProducts.set(false);
    });
  }

  onValueChangeEffect = effect(async () => {
    const collectedOptions = new Set<Interval>();
    this.subscriptionProducts().map((product) => {
      product?.productPrices?.map((price) => collectedOptions.add(price.interval));
    });
    const availableIntervals = Array.from(collectedOptions);
    this.intervalOptions.set(
      await Promise.all(
        availableIntervals.map(async (interval) => ({
          value: interval,
          label: await this.translocoService.translate(`purchase.interval_${interval}`),
        })),
      ),
    );
  });

  onIntervalChange(event: any) {
    this.selectedInterval.set(event.value || this.DEFAULT_INTERVAL);
  }
}
